import request from '../../utils/request';

// 获取BI车次统计数据
export async function getNotices() {
  return request({ url: 'message/notices' });
}
export function clearNotices(params) {
  return request({ url: 'message/clearnotices', params });
}
